angular.module('lingoda.payment', [])
.directive('lingPayment', function() {
    return {
        restrict: 'C',
        scope: true,
        link: function(scope, iElement) {
        }
    }
})
.directive('lingPaymentItem', function() {
    return {
        restrict: 'C',
        link: function(scope, iElement, iAttrs) {
            var checkModel = 'radioCheck[\'' + iElement.find('input').attr('name') + '\'][\'value-' + iElement.find('input').val() + '\']';

            scope.$watch(checkModel, function(v) {
                if(v) {
                    scope.terms = false;
                    //Ajax
                    if(scope.result) {
                        scope.processResult();
                    //Iframe
                    } else if(iAttrs.url) {
                        scope.loadPayment(iAttrs.url);
                    //Static content
                    } else {
                        scope.loadStaticPayment();
                    }
                }
            });
        }
    }
})
.directive('lingPaymentItemContent', function() {
    return {
        restrict: 'C',
        scope: {
            staticContent: '='
        },
        link: function(scope, iElement) {
            scope.staticContent = iElement;
        }
    }
})
.directive('lingPaymentCollapse', function() {
    return {
        restrict: 'C',
        link: function(scope) {
            scope.collapse = true;

            scope.onLoad = function() {
                scope.activeStaticContent = false;
                scope.paymentLoader = false;
            };

            scope.loadStaticPayment = function() {
                if(scope.staticContent) {
                    scope.activeStaticContent = scope.staticContent[scope.radio.optionsRadios];
                }
                scope.collapse = false;
            },

            scope.loadPayment = function(url) {
                //From ajax response
                if(scope.paymentDependency) {
                    //Trigger dependency's function
                    //scope.submitForm();
                } else {
                //From attribute
                    scope.loadIframe(url);
                }
            };

            //Source from ajax
            scope.paymentOptions = {
                'option2': 'creditCards',
                'option5': 'paypal',
                'option6': 'sepadirectdebit'
            };
            scope.$watch('result', function(result) {
                if(result) {
                    scope.processResult();
                } else if(result === false) {
                    scope.collapse = true;
                }
            });
            scope.processResult = function() {
                if(scope.result.data.paymentURLs) {
                    scope.loadIframe(scope.result.data.paymentURLs[scope.paymentOptions[scope.radio.optionsRadios]]);
                }
            };

            scope.loadIframe = function(src) {
                scope.paymentSrc = src;
                scope.onLoad();
            };

            scope.$watch('paymentLoader', function(v) {
                if(v === true) {
                    scope.collapse = true;
                } else if(v === false) {
                    scope.collapse = false;
                }
            });
        }
    }
})
.directive('lingPaymentStaticContent', ['$compile', function($compile) {
    return {
        restrict: 'C',
        link: function(scope, iElement) {
            scope.$watch('activeStaticContent', function(v) {
                if(v) {
                    iElement.html(v.html());
                    $compile(iElement.children())(scope);
                }
            });
        }
    }
}]);
